import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import type { BoxProps } from '@mui/material';
import { Box, Link } from '@mui/material';

import { LogoMark } from './LogoMark';

export type LogoProps = {
    disabledLink?: boolean;
    sx?: BoxProps['sx'];
};

// forwardRef is kept because the surrounding MUI Link forwards a ref to its child.
const Logo = forwardRef<HTMLDivElement, LogoProps>(({ disabledLink = false, sx, ...other }, ref) => {
    const logo = (
        <Box
            ref={ ref }
            component="div"
            role="img"
            aria-label="KataQuiz"
            sx={ {
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                ...sx,
            } }
            { ...other }
        >
            <LogoMark size={ 40 }/>
            <Box component="span" aria-hidden="true" sx={ { fontSize: 24, lineHeight: 1, fontWeight: 900, letterSpacing: '-0.03em', color: '#1B2A4A', whiteSpace: 'nowrap' } }>
                Kata<Box component="span" sx={ { color: '#2754B5' } }>Quiz</Box>
            </Box>
        </Box>
    );

    if (disabledLink) {
        return <>{ logo }</>;
    }

    return (
        <Link to="/" component={ RouterLink } sx={ { display: 'contents' } }>
            { logo }
        </Link>
    );
});

export default Logo;
